/** Ouvrir / copier le portail — Informations ou onglet. */
import { Button } from "../../components/Button";
import type { Client } from "./types";
import { useClientPortalLink } from "./useClientPortalLink";

type ClientPortalActionsProps = {
  client: Client;
  compact?: boolean;
};

function IconPortal() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="4" y="3.5" width="10" height="17" rx="1.6" stroke="currentColor" strokeWidth="1.7" />
      <path d="M14 8h6v8h-6" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
      <circle cx="11.1" cy="12.2" r="0.9" fill="currentColor" />
    </svg>
  );
}

function IconCopy({ done }: { done?: boolean }) {
  if (done) {
    return (
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M5 12.5 10 17.5 19 7.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="8.5" y="8.5" width="11" height="11" rx="1.8" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M6.5 15.5H5.8A1.8 1.8 0 0 1 4 13.7V5.8A1.8 1.8 0 0 1 5.8 4h7.9A1.8 1.8 0 0 1 15.5 5.8V6.5"
        stroke="currentColor"
        strokeWidth="1.7"
      />
    </svg>
  );
}

export function ClientPortalActions({ client, compact = false }: ClientPortalActionsProps) {
  const { enabled, owner, busy, err, copied, openPortal, copyLink } = useClientPortalLink(client);

  if (!enabled) {
    return (
      <div className={compact ? "fx-fiche-portal-mini" : "fx-fiche-portal"}>
        {!compact ? <h3>Portail client</h3> : null}
        <p>Le portail n’est pas activé. Active-le dans Paramètres → Portail.</p>
      </div>
    );
  }

  const openLabel = busy ? "Ouverture…" : compact ? "Portail client" : "Ouvrir le portail";
  const copyLabel = copied ? "Lien copié" : "Copier le lien";

  return (
    <div className={compact ? "fx-fiche-portal-mini" : "fx-fiche-portal"}>
      {!compact ? <h3>Portail client</h3> : null}
      {!compact ? (
        <p>
          Ouvre le dossier de {client.name} comme lui : pièces validées, PDF, choix de société si le même e-mail est
          ailleurs.
        </p>
      ) : null}
      <div className="fx-fiche-portal__acts">
        {compact ? (
          <>
            <button type="button" className="fx-fiche-mini-btn" disabled={busy || !owner} onClick={() => void openPortal()}>
              <IconPortal />
              {openLabel}
            </button>
            <button type="button" className="fx-fiche-mini-btn is-ghost" disabled={busy || !owner} onClick={() => void copyLink()}>
              <IconCopy done={copied} />
              {copyLabel}
            </button>
          </>
        ) : (
          <>
            <Button disabled={busy || !owner} onClick={() => void openPortal()}>
              <span className="fx-fiche-btn-ico">
                <IconPortal />
                {openLabel}
              </span>
            </Button>
            <Button variant="ghost" disabled={busy || !owner} onClick={() => void copyLink()}>
              <span className="fx-fiche-btn-ico">
                <IconCopy done={copied} />
                {copyLabel}
              </span>
            </Button>
          </>
        )}
      </div>
      {!owner ? <p>Seul le propriétaire ouvre le portail.</p> : null}
      {err ? <p className="fx-fiche-portal__err">{err}</p> : null}
    </div>
  );
}
